import React from 'react';
import { situations } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
export function Situations() {
  return <section className="bg-cream px-4 pb-14 sm:px-5 sm:pb-24" data-id="element-214" data-mp="rxubh2lbj755">
      <div className="mx-auto max-w-5xl" data-id="element-215" data-mp="rw9ihhenjw9e">
        <Reveal data-id="element-216" data-mp="vz647gzho8hk">
          <SectionLabel data-id="element-217" data-mp="vzxr83f0sxw8">Ti suona familiare?</SectionLabel>
          <h2 className="display mx-auto mt-5 max-w-[24ch] text-center text-[1.7rem] text-ink sm:text-[2.9rem]" data-id="element-218" data-mp="vxbku73v8ofl">
            Ti suona familiare una di queste situazioni?
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-semibold leading-relaxed text-ink/65 sm:mt-5 sm:text-lg" data-id="element-219" data-mp="15vrbk8yzdvok">
            Il problema non è solo lo schermo. È non avere un’alternativa
            pratica, coinvolgente ed educativa da mettere sul tavolo senza dover
            prima preparare una lezione di ingegneria.
          </p>
        </Reveal>

        <ul className="mt-9 grid gap-4 sm:mt-12 sm:gap-5 md:grid-cols-2" data-id="element-220" data-mp="1oov6ryrukgla">
          {situations.map((situation, index) => <Reveal key={situation.letter} delay={index * 0.05} data-id="element-221" data-mp="3ljhfgoovfcp7" data-mpi={index}>
              <li className="flex h-full gap-4 rounded-[1.5rem] border-2 border-ink/10 bg-white p-5 shadow-edge transition-[transform,box-shadow] duration-150 ease-snap hover:-translate-y-0.5 hover:shadow-card sm:gap-5 sm:rounded-[1.75rem] sm:p-7" data-id="element-222" data-mp="3hg2ztz4ugyca">
                <span className="display flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-ink text-base text-sun sm:h-11 sm:w-11" aria-hidden="true" data-id="element-223" data-mp="37k9fhtkvw0jy">
                  {situation.letter}
                </span>
                <div data-id="element-224" data-mp="3vfu9jnobvskh">
                  <h3 className="text-base font-black leading-snug text-ink sm:text-lg" data-id="element-225" data-mp="3vfc2rx41hvyb">
                    {situation.title}
                  </h3>
                  <p className="mt-2 text-[15px] font-semibold leading-relaxed text-ink/65 sm:text-base" data-id="element-226" data-mp="3qewrrc78d0ji">
                    {situation.description}
                  </p>
                </div>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}